/* 🤖 this file was generated by svg-to-ts */
export const siriusDotsThreeVertical: {
  name: 'dots_three_vertical';
  data: string;
} = {
  name: 'dots_three_vertical',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style="display: block;"><path fill-rule="evenodd" clip-rule="evenodd" d="M12 10.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3ZM9 12a3 3 0 1 1 6 0 3 3 0 0 1-6 0ZM12 3a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3ZM9 4.5a3 3 0 1 1 6 0 3 3 0 0 1-6 0ZM12 18a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Zm-3 1.5a3 3 0 1 1 6 0 3 3 0 0 1-6 0Z" fill="currentColor"/></svg>`
};
